import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { css } from '@styled-system/css'

import { Box } from 'ui/bend'

import { formatEventMapEmbedUrl } from './formatEvent'

const MapFrame = styled(Box)(
  css({
    mt: '16px',
    width: '100%',
    height: ['220px', null, '240px'],
    overflow: 'hidden',
    border: '1px solid',
    borderColor: 'grey2',
    backgroundColor: 'grey1',
    '& iframe': {
      display: 'block',
      width: '100%',
      height: '100%',
      border: 0
    }
  })
)

const EventLocationMap = ({ event }) => {
  const embedUrl = formatEventMapEmbedUrl(event)
  if (!embedUrl) return null

  const mapTitle = event?.venue || event?.title || 'Event location'

  return (
    <MapFrame>
      <iframe
        title={`Map for ${mapTitle}`}
        src={embedUrl}
        loading='lazy'
        referrerPolicy='no-referrer-when-downgrade'
        allowFullScreen
      />
    </MapFrame>
  )
}

EventLocationMap.propTypes = {
  event: PropTypes.object.isRequired
}

export default EventLocationMap
